import React from "react";
import {getDateInFrench, getWeatherImage, sliceText} from "./utils";
import account from "../../images/account.svg"
import styled, {css} from "styled-components";
import {getImage} from "../../utils/utils";
import {LinearProgressBar} from "../progress-bar/LinearProgressBar";
import startIcon from "../../images/project/start.svg"
import endIcon from "../../images/project/end.svg"
import updateIcon from "../../images/update.svg"
import SubTagPlentyCard from "../tag/subTag/SubTagPlentyCard";
import Advancement from "../objective/advancement/Advancement";


const ProjectCard = ({project, okr, type, users}) => {
    const text = project.title ?? project.name
    const title = text.length > 100 ? text.slice(0, 100) + '...' : text
    const members = users?.filter(user => user.projects.map(p => p.id).includes(project.id))
    const tagMembers = members?.filter(member => member.tags.length > 0);

    const returnAdvancementInPercentage = (advancement, target) => {
        const advancementValue = (advancement * 100) / target
        if (advancementValue >= 100){
            return 100
        } else {
            return advancementValue.toFixed(0)
        }
    }
    return (
        <ProjectCardContainer $mode={type}>
            <Card $mode={okr}>
                <p className="project-title"> {title} </p>
                <div className="project-content">
                    <div className="pilot">
                        <img src= { getImage(project.pilot.photo, account) } alt=""/>
                        <p>{project.pilot.firstName}</p>
                        <p>{project.pilot.lastName}</p>
                    </div>
                    <div className="dates">
                        {
                            type === "project" &&
                            <div className="date-item">
                                <img src={startIcon} alt="date de début"/>
                                { project.startDate ? getDateInFrench(project.startDate) : "Non défini"}</div>
                        }
                        <div className="date-item">
                            <img src={endIcon} alt="date de fin"/>
                            { project.endDate ? getDateInFrench(project.endDate) : "Non défini"}</div>
                        <div className="date-item">
                            <img src={updateIcon} alt="dernière mise à jour"/>
                            {getDateInFrench(project.lastUpdate)}</div>
                    </div>
                    <div className="health">
                        <div className="weather">
                            <img src={getWeatherImage(project.weather)} alt=""/>
                        </div>
                        {
                            type == "project" &&
                            LinearProgressBar(project.advancement)
                        }
                        {
                            type == "kr" &&
                            LinearProgressBar(returnAdvancementInPercentage(project.advancement, project.target))
                        }
                    </div>
                </div>
                <TagSection>
                    <div className={"wrapper"}>
                        {tagMembers ?
                            <div style={{display: "flex",alignItems:"center", gap: "0.5rem"}}>
                                <span style={{fontSize: "10px", whiteSpace: "nowrap"}}> {tagMembers[0]?.firstName} {tagMembers[0]?.lastName}</span>
                                {tagMembers[0]?.tags.map(tag => (
                                    <SubTagPlentyCard
                                        key={tag.id + tag.name}
                                        color={tag.color}
                                        id={tag.id}
                                        name={tag.name}
                                        className={"no-hover"}
                                        height={"8px"}
                                    />
                                ))}
                            </div>
                            :
                            null
                        }
                        {project.tags.map(tag => (<SubTagPlentyCard
                            key={tag.id + tag.name}
                            color={tag.color}
                            id={tag.id}
                            category={tag.category}
                            name={tag.name}
                            className={"no-hover"}
                            height={"8px"}
                        />))}
                    </div>

                </TagSection>
            </Card>
                <Comment>
                    <p className={"content"}> {sliceText(project.comment , 120,"Pas de commentaire")}</p>
                </Comment>
        </ProjectCardContainer>
    )
}
const Card = styled.div`
  padding: 0 0.5rem;
  border-radius: 15px;
  box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
  -webkit-print-color-adjust: exact;
  -webkit-filter: opacity(1);
  .project-title{
    text-align: center;
    font-size: 12px;
    margin: 0;
    color: var(--color-purple);
    font-weight: bolder;
    @media screen and (min-width: 1350px){
      font-size: 14px;
    }
    @media print{
      font-size: 10px;
      text-align: left;  
      page-break-inside: avoid;
    }
  }
  .project-content{
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    @media screen and (min-width: 900px){
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
    @media print {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
  }

  .dates{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.5rem;
    @media screen and (min-width: 900px) {
      flex-direction: row;
      justify-content: space-between;
    }
    
    @media print {
      flex-direction: row;
      justify-content: space-between;
    }
  }
  
  .date-item{
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 10px;
    @media print{
      font-size: 8px;
    }
    @media screen and (min-width: 1350px){
      font-size: 12px;
    }
  }
  
  .date-item img{
    max-width: 12px;
    
    @media screen and (min-width: 1350px){
      min-width: 20px;
    }
    @media print {
      max-width: 12px;
    }
  }
  .health{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
  }
  .weather img{
    width: 25px;
    
    @media print{
      width: 25px;
    }
    
    @media screen and (min-width: 1350px){
      width: 45px;
    }
  }

  .pilot{
    display: flex;
    align-items: center;
    gap: 1rem;
    @media print {
      gap: 0.4rem;
    }
  }

  .pilot img{
    border-radius: 50%;
    width: 25px;
    height: 25px;
    @media print{
      width: 25px;
      height: 25px;
    }
    @media screen and (min-width: 1350px){
      width: 50px;
      height: 50px;
    }
  }
  .pilot p {
    font-size: 12px ;
    @media print {
      font-size: 10px;  
    }
  }
  .advancement-div{
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 30%
  }
  
  .advancement-div p{
    font-size: 12px;
  }
  .progress-container {
    height: 0.4rem;
    width: 5rem;
    border-radius: 0.4rem;
    background: dimgrey;
    -webkit-tap-highlight-color: transparent;
    
    @media print{
      height: 0.4rem;
      width: 5rem;
    }
    @media screen and (min-width: 1350px){
      height: 0.6rem;
      width: 8rem;
    }
  }

  .advancement-div p {
    margin: 0;
  }
`
const Comment = styled.div`
    padding: 0.5rem;
    border-radius: 15px;
    box-shadow: rgba(0, 0, 0, 0.12) 0 6px 16px;
    -webkit-print-color-adjust: exact;
    -webkit-filter: opacity(1);
    .content{
      font-size: 9px;
      text-align: center;
      @media screen and (min-width: 900px){
        font-size: 11px;
        text-align: left;
      }
      @media print{
        font-size: 7px;
        text-align: left;
      }
    }
`

const ProjectCardContainer = styled.div`
  gap:0.5rem;
  display: grid;
  grid-template-rows: repeat(2, minmax(1fr,1fr));
  @media screen and (min-width: 900px){
    display: grid;
      ${(props) => {
          switch (props.$mode){
              case "project":
                  return css`
                      grid-template-columns: 80% 20%;
                  ;
                  `
              default:
                  return css`
                    grid-template-columns: 70% 20%;
                    justify-content: flex-end;
                  `
          }
      }
  }}
  
  @media print{
      display: grid;
      ${(props) => {
          switch (props.$mode){
              case "project":
                  return css`
                      grid-template-columns: 80% 20%;
                  ;
                  `
              case "kr":
                  return css`
                      grid-template-columns: 70% 20%;
                      justify-content: flex-end;
                  ;
                  `
              default:
                  return css`
                      grid-template-columns: 75% 20%;
                      justify-content: flex-end;
                  `
          }
      }
      }
  }}
  
`
const TagSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  padding: 0 1rem;
  width: 100%;
  grid-column: 1/5;
  .wrapper {
    display: flex;
    flex-direction: row;
    margin: 0 0.5em;
    width: 100%;
    gap: 0.5rem;
    padding: 0.3rem;
    overflow-x: hidden;
  }
`;
export default ProjectCard